import { render, staticRenderFns } from "./NewSlideModal.vue?vue&type=template&id=29ed1280&scoped=true&"
import script from "./NewSlideModal.vue?vue&type=script&lang=js&"
export * from "./NewSlideModal.vue?vue&type=script&lang=js&"
import style0 from "./NewSlideModal.vue?vue&type=style&index=0&id=29ed1280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed1280",
  null
  
)

export default component.exports